'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.set = set;
exports.push = push;
exports.merge = merge;
exports.remove = remove;

var _update = require('./update');

var _update2 = _interopRequireDefault(_update);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathToString = function pathToString(path) {
    return Array.isArray(path) ? path.join('.') : path;
};

var makePath = function makePath(path) {
    return Array.isArray(path) ? path : ('' + path).split('.');
};

function set(obj, path, value) {
    if (value instanceof Function) {
        return (0, _update2.default)(obj, makePath(path), value);
    }

    return (0, _update2.default)(obj, makePath(path), function () {
        return value;
    });
}

function push(obj, path, item) {
    return (0, _update2.default)(obj, makePath(path), function (value) {
        if (Array.isArray(value)) {
            return value.concat(item);
        }

        throw 'Can\'t push item by path \'' + pathToString(path) + '\': leaf is not an array';
    });
}

function merge(obj, path, item) {
    return (0, _update2.default)(obj, makePath(path), function (value) {
        if (value instanceof Object || value === undefined) {
            var hasNoUpdates = value && Object.keys(item).every(function (key) {
                return value[key] === item[key];
            });

            if (hasNoUpdates) {
                return value;
            }

            return Object.assign({}, value, item);
        }

        throw 'Can\'t merge items by path \'' + pathToString(path) + '\': leaf is not an object';
    });
}

function remove(obj, path) {
    var accessPath = makePath(path);
    var key = accessPath.pop();

    var doRemove = function doRemove(value) {
        if (Array.isArray(value)) {
            if (value.length <= key) {
                return value;
            }

            return value.slice(0, key).concat(value.slice(key + 1));
        }

        if (value instanceof Object) {
            if (!value.hasOwnProperty(key)) {
                return value;
            }

            var result = Object.assign({}, value);
            delete result[key];
            return result;
        }

        if (value === undefined) {
            throw 'Can\'t remove items by path \'' + pathToString(path) + '\': parent leaf is not exists';
        }

        throw 'Can\'t remove items by path \'' + pathToString(path) + '\': parent leaf is not an object or array';
    };

    if (accessPath.length > 0) {
        return (0, _update2.default)(obj, accessPath, doRemove);
    } else {
        return doRemove(obj);
    }
}